module.exports = __webpack_public_path__ + "img/main_guy_mobile_side_crop.39b15708.png";